function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M258.831,77.19h16.338c0.517,0,0.831,0.348,0.831,0.831v10.626c0,0.242-0.195,0.436-0.436,0.436h-17.128 c-0.242,0-0.436-0.195-0.436-0.436V78.021C258,77.573,258.337,77.19,258.831,77.19z"
});

var SvgInstallWin = function SvgInstallWin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 289 104",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E4C59"
    },
    d: "M0,6c0-3.314,2.686-6,6-6h277c3.314,0,6,2.686,6,6v17H0V6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M278,8.364l-2.003-1.923l-0.413-0.397c-0.061-0.059-0.16-0.059-0.221,0l-0.442,0.424 c-0.061,0.058-0.061,0.154,0,0.212L277.337,9l-2.416,2.32c-0.061,0.059-0.061,0.153,0,0.212l0.442,0.425 c0.061,0.058,0.16,0.058,0.221,0L278,9.636l2.416,2.32c0.061,0.058,0.16,0.058,0.221,0l0.442-0.424c0.061-0.059,0.061-0.154,0-0.212 L278.663,9l2.003-1.923l0.413-0.397c0.061-0.058,0.061-0.154,0-0.212l-0.442-0.424c-0.061-0.059-0.16-0.059-0.221,0L278,8.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DDE1"
    },
    d: "M2,57.302h285c1.105,0,2,0.895,2,2V102c0,1.105-0.895,2-2,2H2c-1.105,0-2-0.895-2-2V59.302 C0,58.197,0.895,57.302,2,57.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DDE1"
    },
    d: "M217.945,49L210,57.302h15.89L217.945,49z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 73,
    style: {
      fill: "#BBC8D1"
    },
    width: 183,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 84,
    style: {
      fill: "#BBC8D1"
    },
    width: 183,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 23,
    style: {
      fill: "#D8DDE1"
    },
    width: 289,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E4C59"
    },
    d: "M222.891,33.336l-4.625,4.927c-0.147,0.156-0.385,0.156-0.532,0l-4.625-4.927 c-0.146-0.156-0.146-0.408,0-0.564l0.613-0.651c0.15-0.159,0.39-0.156,0.534,0.007l2.928,3.224v-7.261 c0-0.219,0.169-0.398,0.375-0.398h0.875c0.207,0,0.375,0.179,0.375,0.398v7.261l2.929-3.224c0.146-0.159,0.387-0.163,0.534-0.007 l0.612,0.651C223.037,32.928,223.037,33.18,222.891,33.336L222.891,33.336z M223.625,39.841h-11.25 c-0.206,0-0.375,0.179-0.375,0.398v0.93c0,0.219,0.169,0.399,0.375,0.399h11.25c0.206,0,0.375-0.179,0.375-0.399v-0.93 C224,40.02,223.831,39.841,223.625,39.841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#A8BCCE",
      strokeWidth: 0.25
    },
    d: "M9,29.125h192c1.036,0,1.875,0.839,1.875,1.875v8 c0,1.036-0.839,1.875-1.875,1.875H9c-1.036,0-1.875-0.839-1.875-1.875v-8C7.125,29.964,7.965,29.125,9,29.125z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3E4C59",
      fillOpacity: 0.2
    },
    cx: 239,
    cy: 35,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3E4C59",
      fillOpacity: 0.2
    },
    cx: 258,
    cy: 35,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3E4C59",
      fillOpacity: 0.2
    },
    cx: 277,
    cy: 35,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DDE1"
    },
    d: "M16,11c0-1.105,0.895-2,2-2h67c1.105,0,2,0.895,2,2v14c0,1.105-0.895,2-2,2H18c-1.105,0-2-0.895-2-2 V11z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 73,
    style: {
      fill: "#A8BCCE"
    },
    width: 17,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484949"
    },
    d: "M258.831,74.92h4.085c0.689-0.036,0.816,0.261,1,0.477l0.646,0.815 c0.053,0.066,0.103,0.09,0.215,0.09h10.391c0.517,0,0.831,0.348,0.831,0.831v11.514c0,0.242-0.195,0.436-0.436,0.436h-17.128 c-0.242,0-0.436-0.195-0.436-0.436V75.751C258,75.303,258.337,74.92,258.831,74.92z"
  }), _ref2, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#445B7D",
      strokeWidth: 0.5,
      strokeOpacity: 0.5
    },
    d: "M245.5,66.5v31"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstallWin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/installWin.43fc9611.svg";
export { ForwardRef as ReactComponent };